export default __webpack_public_path__ + "static/4_31-168942f05bbc58ad83c073800e053553.png";